import React, { ForwardedRef, useContext } from 'react';
import { OriginIconProps } from '../type';
import { Context } from '../context';

function IconPeopleSolidComponent(props: OriginIconProps, ref: ForwardedRef<SVGSVGElement>) {
    const { prefix: prefixFromContext } = useContext(Context);
    const { className = '', prefix: prefixFromProps, width = '1em', height = '1em', useCurrentColor = true, spin, ...rest } = props;

    const prefix = prefixFromProps || prefixFromContext || 'alliance';
    const loadingKls = spin ? ` ${prefix}-icon-loading` : '';
    return <svg className={`${prefix}-icon ${prefix}-icon-PeopleSolid${loadingKls} ${className}`} width={width} height={height} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest} ref={ref}><path fillRule="evenodd" clipRule="evenodd" d="M24 22.823c5.05 0 9.144-4.213 9.144-9.411C33.144 8.214 29.05 4 24 4c-5.05 0-9.143 4.214-9.143 9.412 0 5.197 4.093 9.411 9.143 9.411zm16 18.823c0-9.096-7.163-16.47-16-16.47S8 32.55 8 41.646C8 42.946 9.023 44 10.286 44H37.714C38.976 44 40 42.946 40 41.646z" fill={useCurrentColor ? 'currentColor' : '#FFC240'}/></svg>;
}

const IconPeopleSolid = React.forwardRef(IconPeopleSolidComponent);
export default IconPeopleSolid;
